import type { Component, Entity2D } from '../../odie';

import type { WallBlockProps } from '../defs/block';
import { config } from '../defs/config';
import { WallBlockView } from '../views/blocks/WallBlockView';

// types
//-----------------------------------------------------------------------------
export type WallBlockComponentOptions = {
  props: WallBlockProps;
  count?: number;
};

/*
  Wall block component
*/
export class WallBlockComponent implements Component {
  public static readonly NAME = 'blockWall';

  public get counter(): number {
    return this._counter;
  }
  public set counter(value: number) {
    value = Math.max(0, value);
    this._counter = value;
    this.view.updateCounter(value);
  }

  public get hitPoints() {
    return this._hitPoints;
  }

  public set hitPoints(value: number) {
    value = Math.max(0, value);
    this._hitPoints = value;
  }

  public get props(): WallBlockProps {
    return this.options.props;
  }

  public entity!: Entity2D;
  public view!: WallBlockView;

  private _counter!: number;
  /** Hit points is a temporary hit counter, used for selecting targets before they are actually hit */
  private _hitPoints!: number;
  private options!: WallBlockComponentOptions;

  public init(options: WallBlockComponentOptions): void {
    this.view = new WallBlockView(options.props);
    this.options = options;
    this.counter = options.count || options.props.count;
    this.hitPoints = this.counter;
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState() {
    return this._counter;
  }

  public getViewWidth() {
    return this.options.props.width * config.tile.size;
  }

  public getViewHeight() {
    return this.options.props.height * config.tile.size;
  }
}
